import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Textarea,
  Button,
  Image,
} from '@nextui-org/react';
import { IoMdClose } from 'react-icons/io';
import InputModal from '../Modal/InputModal';

function CommentReplyBox({ onPress, onSubmit, isLoading }) {
  const [file, setFile] = useState(null);
  const [comment, setComment] = useState('');

  const handleFileChange = (file) => setFile(file);
  const handleCommentChange = (e) => setComment(e.target.value);

  const handleSubmit = () => {
    onSubmit(comment, file);
    setComment('');
    setFile(null);
    onPress();
  };

  return (
    <Card className="bg-background-secondary-color font-poppins mb-4">
      <CardHeader className="text-white flex justify-between">
        <h2 className="text-md font-bold">Add your comment...</h2>
        <div onClick={onPress}>
          <IoMdClose size={20} className="text-red-500 md:hidden" />
        </div>
      </CardHeader>
      <CardBody>
        <Textarea
          onChange={handleCommentChange}
          placeholder="Add your comment here.."
          className="text-xs text-gray-300"
        />
        {file && <Image src={URL.createObjectURL(file)} alt="Selected file" />}
      </CardBody>
      <CardFooter>
        <CardFooter className="justify-between items-center">
          {/* modal */}
          <InputModal onChange={handleFileChange} />

          {/* btns */}
          <div className="flex justify-between md:justify-end gap-6">
            <Button
              onPress={onPress}
              variant="light"
              color="danger"
              className="font-poppins font-medium hidden md:block text-xs "
              size="sm"
            >
              Discard
            </Button>

            <Button
              isLoading={isLoading}
              onPress={handleSubmit}
              className="bg-btn-color text-gray-800 font-poppins font-medium text-xs "
              size="sm"
            >
              Post
            </Button>
          </div>
        </CardFooter>
      </CardFooter>
    </Card>
  );
}

export default CommentReplyBox;
